import { useDocumentTitle } from "../../hooks";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import MenuItem from "../../components/admin/menu/MenuItem";
import { getApprovalSettingTopPage } from "../../api/setting/pageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import BackendLayout from "../../layouts/BackendLayout";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import { APPROVAL_SETTING_MASTER_DASHBOARD } from "../../constants/routes";
import { PageTitle } from "../../components/admin";
import { clearPageLoading, setPageLoading } from "../../store/actions";
import { errorStatusHandle } from "../../utils";
import {APPROVAL_SETTING_MASTER_DASHBOARD_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";
import {RedirectAlert} from "../../components";

const ApprovalSettingTopPage = () => {
  useRedirectPage(APPROVAL_SETTING_MASTER_DASHBOARD_PAGE);
  const [menuItems, setMenuItems] = useState([]);
  const dispatch = useDispatch();
  useDocumentTitle("承認設定マスタトップ - 点検王");
  const breadcrumb = getRouteBreadcrumb(APPROVAL_SETTING_MASTER_DASHBOARD);

  //Function help to set page settings
  const setApprovalSettingTopPageSettings = async (e) => {
    dispatch(setPageLoading());
    try {
      const pageSettings = await getApprovalSettingTopPage();
      dispatch(setPageSettings(pageSettings));
      setMenuItems(pageSettings.menu_items);
    } catch (e) {
      errorStatusHandle(e);
    } finally {
      dispatch(clearPageLoading());
    }
  };

  useEffect(() => {
    setApprovalSettingTopPageSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <PageTitle title="承認設定マスタトップ" />
      <RedirectAlert />
      <div className="grid approval-master-items gap-x-8 gap-y-8 py-[20px]">
        {menuItems.map((item, index) => (
          <MenuItem key={index} menu={item.name} feature="approval-settings" />
        ))}
      </div>
    </BackendLayout>
  );
};

export default ApprovalSettingTopPage;
